import React, { useState, useEffect } from 'react'
import SessionBar from '../Components/SessionBar/SessionBar';
import './AssetDraft.css';
import api from "../services/api";
import { useNavigate } from 'react-router-dom';
import pick1 from '../assets/icons/pick1.svg';

const AssestDraft = ({ user }) => {
  const [userid, setUserId] = useState("");
  const [assetid, setAssetId] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    if (user?.user_id) {
      setUserId(user.user_id);
    }
  }, [user]);

  const handlePickClick = async () => {
    if (!userid) {
      alert('Please enter User ID first');
      return;
    }
    try {
      const { data } = await api.get(`/user/${userid}`);
      localStorage.setItem('assetPickerData', JSON.stringify(data));
      const newWindow = window.open('/asset-picker', '_blank', 'width=700,height=500,left=300,top=200');

      window.addEventListener('message', (event) => {
        if (event.origin !== window.location.origin) {
          return;
        }
        if (event.data.type === 'ASSET_SELECTED') {
          setAssetId(event.data.assetNo);
          if (newWindow) newWindow.close();
        }
      });
    } catch (err) {
      if (err.message === 'Session expired') {
                return;
            }else{
      console.error(err);
      alert('Failed to fetch assets');
            }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!userid || !assetid) {
      alert('Please enter both User ID and Asset Number');
      return;
    }
    try {
      const { data } = await api.get(`/asset/${userid}/${assetid}`);
      if (data) {
        navigate("/results", { state: { asset: data, userid, assetid } });
      }
      else {
        alert("Error in getting data. Please contact system administrator.")
      }
    }
    catch (err) {
      console.error(err);
      alert("Error in getting data. Please contact system administrator.");
    }
  };

  return (
    <div>
      <SessionBar name='Asset Verification' />
      <div className='grid-container'>
        <form className='form' onSubmit={handleSubmit}>
          <div className='Form-body'>
            <div className='grid-item-label'><label> User Id</label></div>
            <div className='grid-item'><input className='input' type='text' value={userid} readOnly required /></div>
          </div>
          <div className='Form-body'>
            <div className='grid-item-label'><label> Asset No</label></div>
            <div className='grid-item' style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              <input className='input asset' type='text' value={assetid} onChange={(e) => setAssetId(e.target.value)} required />
              <img src={pick1} alt='Pick' onClick={handlePickClick} style={{ cursor: 'pointer', width: '24px', height: '24px' }} />
            </div>
          </div>
          <div className='Button-container'><button className='Form-button' type="submit">GET</button></div>
        </form>
      </div>
      <div>
        <p className='text'>Please enter only Fixed Part of Asset Number in Input Filter. e.g. To get details of FAPC08I0039-803VIK enter FAPC08I0039 in Asset Number.</p>
      </div>
    </div>
  )
}

export default AssestDraft;